import { render } from "./info_adicional.vue?vue&type=template&id=6afe3784"
import script from "./info_adicional.vue?vue&type=script&lang=js"
export * from "./info_adicional.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__